<!-- Footer -->
<p class="clearfix mb-0">
  <span class="float-md-left d-block d-md-inline-block mt-25">
    COPYRIGHT &copy; {{ year }}
    <a class="ml-25" href="https://www.sidc.coop/" target="_blank">SIDC</a>
    <span class="d-none d-sm-inline-block">, All rights Reserved</span>
  </span>
</p>
<!--/ Footer -->

<!-- Move to top Button-->
<app-scroll-top *ngIf="coreConfig.layout.scrollTop"></app-scroll-top>


<!-- Buynow Button-->
<!-- <div class="directory-list">
  <a class="btn btn-success"
  (click)="toggleSidebar('modal-directory-list')"
    >
    <span [data-feather]="'phone-call'"></span>
    </a
  >
</div> -->

  <!-- Add Validation Header Sidebar -->
  <!-- <core-sidebar class="modal modal-slide-in sidebar-todo-modal fade" name="modal-directory-list"
    overlayClass="modal-backdrop" hideOnEsc="true">
    <app-phone-directory></app-phone-directory>
  </core-sidebar> -->
  <!--/  Add Validation Header Sidebar -->



